import { boolean, intersect, literal, number, string, struct, union } from 'io-ts/Decoder';

export const AdditionalParameterValue = intersect(
	struct({
		parameterId: string,
		value: union(number, boolean),
	})
)(
	struct({
		parameterRef: string,
		label: string,
		parameterType: union(literal('boolean'), literal('integer'), literal('decimal')),
	})
);
